import React, { useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ChildHeader from 'components/Dashboard/Main/ChildHeader';
import { Center, Box, Flex, Text, Button, VStack } from '@chakra-ui/react';
import { AccountContext } from 'components/AccountContext';

function PagarParcela() {
  const state = useLocation();
  const navigate = useNavigate();
  const { user } = useContext(AccountContext);
  const { mensalidade, theme, descricao_plano } = state.state;
  const dataExtenso = new Date(mensalidade.data).toLocaleString('pt-BR', { month: 'long' });
  let array = [];

  async function pagamentoParcela() {
    array.push({ parcela_id: mensalidade.paciente_contrato_parcelas_id, valor: mensalidade.valor, valor_desconto: 0 });
    const payload = {
      paciente_id: user.id_cliente_deovita,
      username: user.name,
      parcelsActive: true,
      paciente_contrato_id: user.id_contrato,
      valor: mensalidade.valor,
      valor_desconto: 0,
      status: 'pagamento de divida',
      expiration_pix_in_min: 5,
      navig_to: '/perfil/pagamento/processar-pagamento',
      item: {
        paciente_id: user.id_cliente_deovita,
        descricao: 'Pagamento parcelas em atraso',
        paciente_contrato_parcelas_id: array.map((item) => ({
          parcela_id: item.parcela_id,
          valor: item.valor,
          valor_desconto: item.valor_desconto,
        })),
        paciente_contrato_id: user.id_contrato,
        valor: mensalidade.valor,
        valor_desconto: 0,
        status: 'pagamento de divida',
        whatsapp: user.phone1 || user.phone2,
        nome: user.name,
        valor_pendente: user?.qntdeParcelas?.valorParcelas,
        motivo: '',
        desconto: false,
        pagamentoAdesao: false,
        dadosClienteImportado: null,
        split: null,
        split_rules: null,
        service: 'settle_the_debt',
      },
      orientacoes: '',
      service: 'settle_the_debt',
      confim: true,
      arrayPagamento: array,
      split: [],
      settle_the_debt_payment_view: true,
      frequenciaText: 'Pagamento de divida'
    };
    console.log("payload ", payload)
  
    navigate('/pagamentos', { state: payload });
  }

  return (
    <>
      <ChildHeader />
      <Flex direction="column" justify="space-between" minH="70vh">
        <VStack>
          <Center>
            <Box overflowX="auto" whiteSpace="nowrap" px={8} mt={'5%'}>
              <Box position="relative" display="inline-block" bg="#F3F3F3" borderRadius="0.8em" w="320px" mr={4} p={4} mb={'1em'}>
                <Flex direction="column" gap={2} mb={2}>
                  <Text as="span" color="#888888" fontWeight="bold" fontSize="lg">
                    {dataExtenso.charAt(0).toUpperCase() + dataExtenso.slice(1)}
                  </Text>

                  <Text color="#585858" fontSize="20px">
                    <Text
                      as="span"
                      fontWeight="bold"
                      color={mensalidade?.ativo === false ? theme.background : new Date(mensalidade.data) < new Date() ? '#D60000' : '#5AB2AE'}
                    >
                      {new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      }).format(parseFloat(mensalidade.valor))}
                    </Text>
                  </Text>
                </Flex>

                <Flex direction="column" mt="0.5em">
                  <Text color="#585858" fontSize="sm">
                    Plano:{' '}
                    <Text as="span" color="#888888" fontWeight="bold">
                      {descricao_plano.charAt(0).toUpperCase() + descricao_plano.slice(1).toLowerCase()}
                    </Text>
                  </Text>

                  <Text color="#585858" fontSize="sm">
                    Vencimento:{' '}
                    <Text as="span" color="#888888" fontWeight="bold">
                      {new Date(mensalidade.data).toLocaleDateString('pt-BR', {
                        day: '2-digit',
                        month: '2-digit',
                      })}
                    </Text>
                  </Text>
                </Flex>
              </Box>
            </Box>
          </Center>
        </VStack>

        <Box p={4}>
          <Button
            w="100%"
            bg={theme.background}
            color={theme.fontcolor}
            borderRadius="0.8em"
            onClick={() => {
              pagamentoParcela();
            }}
          >
            Pagar mensalidade
          </Button>
        </Box>
      </Flex>
    </>
  );
}

export default PagarParcela;
